import * as React from 'react';

import * as styles from './Hero.css';
import { clsx } from 'clsx';
import { DobroshriftTitle } from './DobroshriftTitle';

export interface IHeroProps {
  title: string;
  isDobroshriftEnabled: boolean;
  isChildrenDayEnabled: boolean;
  filtersBlock: React.ReactNode;
  isRedesignEnabled: boolean;
}

export function Hero({
  title,
  isDobroshriftEnabled,
  isChildrenDayEnabled,
  filtersBlock,
  isRedesignEnabled: isRedisignEnabled,
}: IHeroProps) {
  const isTitleTransparent = isDobroshriftEnabled || isChildrenDayEnabled;

  return (
    <div className={clsx(styles['wrapper'])}>
      <div data-mark="Hero">
        {isDobroshriftEnabled && (
          <div className={styles['dobroshrift']}>
            <DobroshriftTitle />
            <div>
              <a
                className={styles['dobroshrift-link']}
                href="https://dobroshrift.ru/"
                rel="noopener noreferrer"
                target="_blank"
              >
                #доброшрифт
              </a>
            </div>
          </div>
        )}
        {isChildrenDayEnabled && (
          <div className={clsx(styles['title'], styles['children-day'])}>
            <a
              href="https://doma.otkazniki.ru/?utm_source=cian_ru&utm_medium=zagolovok&utm_campaign=domoy_cian"
              rel="noopener noreferrer"
              target="_blank"
              className={styles['children-day-link']}
            >
              #детихотятдомой поможем каждому ребенку расти в семье!
            </a>
          </div>
        )}
        <div
          className={clsx(
            styles['title'],
            isTitleTransparent && styles['title-transparent'],
            isRedisignEnabled && styles['title-redisign'],
          )}
        >
          {title}
        </div>
        {filtersBlock}
      </div>
    </div>
  );
}
